import { useEffect, useState } from "react";
import { useSectorContext } from "api/settings/sector/SectorProvider";
import { FormattedMessage } from "react-intl";
import { HandleModaleBO } from "components/bo/HandleModaleBO";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { TableManager } from "components/bo/admin-table/TableManager";
import { ACTIONS, ENTITIES } from "constants/constants";
import { navigateView, navigateEdit, navigateToParent } from "utils/boHelper";
import Button from "core/buttons/button/Button";

export default function AdminSector({ action }) {
  const navigate = useNavigate();
  const location = useLocation();
  const { id } = useParams();
  const {
    sectorByIdGetter,
    sectorCreate,
    sectorDeleteById,
    sectorList,
    sectorListGetter,
    sectorPerId,
    sectorUpdateById,
  } = useSectorContext();

  const sectorForm = [
    { col: "en", mandatory: true, isMissingValue: null },
    { col: "fr", mandatory: true, isMissingValue: null },
    { col: "webhook", mandatory: true, isMissingValue: null },
  ];

  const [deleteData, setDeleteData] = useState(null);

  useEffect(() => {
    sectorListGetter();
  }, [sectorListGetter]);

  useEffect(() => {
    if (id) {
      sectorByIdGetter(id);
    }
  }, [id]);

  const handleDelete = async (recruId) =>
    setDeleteData(sectorList.find((e) => e.id === recruId));

  const validateDelete = async (recruId) => {
    try {
      await sectorDeleteById(recruId);
    } catch (error) {
      console.error(error);
    }
  };
  const handleCreate = (payload) => {
    try {
      sectorCreate(payload);
      navigateToParent(navigate, location);
    } catch (e) {
      console.error(e);
    }
  };
  const handleEdit = (payload) => {
    try {
      sectorUpdateById(payload.id, payload);
      navigateToParent(navigate, location);
    } catch (e) {
      console.error(e);
    }
  };
  // Todo gestion droits admin
  return (
    <div>
      {action === ACTIONS.LIST && (
        <div className="flex">
          <Button
            className="btn-hover-color"
            size="large"
            color="blue"
            onClick={() => navigateView("new", navigate, location)}
          >
            <FormattedMessage
              id={"admin_create_new"}
              defaultMessage={"Nouveau"}
            />
          </Button>
        </div>
      )}
      <br />
      <TableManager
        action={action}
        entity={ENTITIES.SECTOR}
        entityPerId={sectorPerId}
        list={sectorList}
        inputs={sectorForm}
        navigateEdit={(propsId) => navigateEdit(propsId, navigate, location)}
        navigateView={(propsId) => navigateView(propsId, navigate, location)}
        handleCreate={handleCreate}
        handleDelete={handleDelete}
        handleEdit={handleEdit}
      />

      <div id="modalDelete">
        <HandleModaleBO
          setDeleteData={setDeleteData}
          validateDelete={validateDelete}
          deleteData={deleteData}
          entity={ENTITIES.SECTOR}
        />
      </div>
    </div>
  );
}
